<form [formGroup]="physicalAbilityForm">
  <div class="step-container">
    <div *ngIf="isJsonShow">
      {{physicalAbilityForm.value | json}}

    </div>
    <ng-template #labelNine>{{ getTranslation('physicalAbility.title') }}</ng-template>
    <div class="step-title">
      {{ isEditable ? getTranslation('physicalAbility.title') : getTranslation('physicalAbility.blockedForEdit') }}
      <span *ngIf="!isEditable" class="badge badge-warning ml-2" style="font-size: 0.75rem;">(Read Only)</span>
    </div>



 




    <div class="row gx-2">
      <!-- Neck or shoulders -->
      <div class="form-group col-12 mb-3">
        <div class="row">
          <label class="form-label col-md-5 mb-0"
            [ngClass]="{'text-danger': submitted && physicalAbilityForm.controls['HasPainNeckOrShoulders'].invalid}">{{ getTranslation('physicalAbility.neckOrShouldersQuestion') }} <span class="text-danger">*</span></label>
          <div class="col-md-4 d-flex align-items-center">
            <label class="mr-5"><input type="radio" class="form-check-input" formControlName="HasPainNeckOrShoulders"
                [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
            <label><input type="radio" class="form-check-input" formControlName="HasPainNeckOrShoulders" [value]="false"
                class="me-2"> {{ getTranslation('common.no') }}</label>

            <div *ngIf="submitted && physicalAbilityForm.controls['HasPainNeckOrShoulders'].invalid"
              class="text-danger-val">
              {{ getTranslation('validation.requiredField') }}
            </div>

          </div>
        </div>
      </div>

      <!-- HasPainBack -->
      <div class="form-group col-12 mb-3">
        <div class="row">
          <label class="form-label col-md-5 mb-0" 
          [ngClass]="{'text-danger': submitted && physicalAbilityForm.controls['HasPainBack'].invalid}" >{{ getTranslation('physicalAbility.backQuestion') }} <span
              class="text-danger">*</span></label>
          <div class="col-md-4 d-flex align-items-center">
            <label class="mr-5"><input type="radio" class="form-check-input" formControlName="HasPainBack"
                [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
            <label><input type="radio" class="form-check-input" formControlName="HasPainBack" [value]="false"
                class="me-2"> {{ getTranslation('common.no') }}</label>


            <div *ngIf="submitted && physicalAbilityForm.controls['HasPainBack'].invalid" class="text-danger-val">
              {{ getTranslation('validation.requiredField') }}
            </div>

          </div>
        </div>
      </div>

      <!-- HasPainKnees -->
      <div class="form-group col-12 mb-3">
        <div class="row">
          <label class="form-label col-md-5 mb-0"
          [ngClass]="{'text-danger': submitted && physicalAbilityForm.controls['HasPainKnees'].invalid}" >{{ getTranslation('physicalAbility.kneesQuestion') }} <span
              class="text-danger">*</span></label>
          <div class="col-md-4 d-flex align-items-center">
            <label class="mr-5"><input type="radio" class="form-check-input" formControlName="HasPainKnees"
                [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
            <label><input type="radio" class="form-check-input" formControlName="HasPainKnees" [value]="false"
                class="me-2"> {{ getTranslation('common.no') }}</label>


            <div *ngIf="submitted && physicalAbilityForm.controls['HasPainKnees'].invalid" class="text-danger-val">
              {{ getTranslation('validation.requiredField') }}
            </div>

          </div>
        </div>
      </div>

      <!-- HasPainHips -->
      <div class="form-group col-12 mb-3">
        <div class="row">
          <label class="form-label col-md-5 mb-0"
          [ngClass]="{'text-danger': submitted && physicalAbilityForm.controls['HasPainHips'].invalid}" >{{ getTranslation('physicalAbility.hipsQuestion') }} <span
              class="text-danger">*</span></label>
          <div class="col-md-4 d-flex align-items-center">
            <label class="mr-5"><input type="radio" class="form-check-input" formControlName="HasPainHips"
                [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
            <label><input type="radio" class="form-check-input" formControlName="HasPainHips" [value]="false"
                class="me-2"> {{ getTranslation('common.no') }}</label>


            <div *ngIf="submitted && physicalAbilityForm.controls['HasPainHips'].invalid" class="text-danger-val">
              {{ getTranslation('validation.requiredField') }}
            </div>

          </div>
        </div>
      </div>

      <!-- HasPainFeet -->
      <div class="form-group col-12 mb-3">
        <div class="row">
          <label class="form-label col-md-5 mb-0"   
          [ngClass]="{'text-danger': submitted && physicalAbilityForm.controls['HasPainFeet'].invalid}">{{ getTranslation('physicalAbility.feetQuestion') }} <span
              class="text-danger">*</span></label>
          <div class="col-md-4 d-flex align-items-center">
            <label class="mr-5"><input type="radio" class="form-check-input" formControlName="HasPainFeet"
                [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
            <label><input type="radio" class="form-check-input" formControlName="HasPainFeet" [value]="false"
                class="me-2"> {{ getTranslation('common.no') }}</label>


            <div *ngIf="submitted && physicalAbilityForm.controls['HasPainFeet'].invalid" class="text-danger-val">
              {{ getTranslation('validation.requiredField') }}
            </div>


          </div>
        </div>
      </div>

      <!-- Hands, wrists or arms -->
      <div class="form-group col-12 mb-3">
        <div class="row">
          <label class="form-label col-md-5 mb-0"
          [ngClass]="{'text-danger': submitted && physicalAbilityForm.controls['HasPainHandsWristsOrArms'].invalid}" >{{ getTranslation('physicalAbility.handsWristsArmsQuestion') }} <span
              class="text-danger">*</span></label>
          <div class="col-md-4 d-flex align-items-center">
            <label class="mr-5"><input type="radio" class="form-check-input" formControlName="HasPainHandsWristsOrArms"
                [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
            <label><input type="radio" class="form-check-input" formControlName="HasPainHandsWristsOrArms"
                [value]="false" class="me-2"> {{ getTranslation('common.no') }}</label>


            <div *ngIf="submitted && physicalAbilityForm.controls['HasPainHandsWristsOrArms'].invalid"
              class="text-danger-val">
              {{ getTranslation('validation.requiredField') }}
            </div>

          </div>
        </div>
      </div>

      <!-- If Yes to any of the above -->
      <div class="form-group col-12 mb-3" *ngIf="hasPhysicalLimitations()">
        <label for="PhysicalLimitationsDetails" class="form-label">{{ getTranslation('physicalAbility.preventedActivitiesQuestion') }} <span class="text-danger">*</span></label>
        <textarea class="form-control" id="PhysicalLimitationsDetails" formControlName="PhysicalLimitationsDetails"
          placeholder="{{ getTranslation('placeholder.enterDetails') }}"  maxlength="500"></textarea>

        <div *ngIf="submitted && physicalAbilityForm.controls['PhysicalLimitationsDetails'].invalid"
          class="text-danger">
          {{ getTranslation('validation.requiredField') }}
        </div>

      </div>

      <!-- Repetitive Strain Injury -->
      <div class="form-group col-12 mb-3">
        <div class="row">
          <label class="form-label col-md-5 mb-0"
          [ngClass]="{'text-danger': submitted && physicalAbilityForm.controls['HasRepetitiveStrainInjury'].invalid}"  >{{ getTranslation('physicalAbility.repetitiveStrainInjuryQuestion') }} <span
              class="text-danger">*</span></label>
          <div class="col-md-4 d-flex align-items-center">
            <label class="mr-5"><input type="radio" class="form-check-input" formControlName="HasRepetitiveStrainInjury"
                [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
            <label><input type="radio" class="form-check-input" formControlName="HasRepetitiveStrainInjury"
                [value]="false" class="me-2"> {{ getTranslation('common.no') }}</label>

            <div *ngIf="submitted && physicalAbilityForm.controls['HasRepetitiveStrainInjury'].invalid"
              class="text-danger-val">
              {{ getTranslation('validation.requiredField') }}
            </div>

          </div>
        </div>
      </div>

      <!-- If Yes for Repetitive Strain Injury -->
      <div class="form-group col-12 mb-3" *ngIf="physicalAbilityForm.get('HasRepetitiveStrainInjury')?.value === true">
        <label for="RepetitiveStrainInjuryDetails" class="form-label"> {{ getTranslation('physicalAbility.whenAndHowLong') }} <span
            class="text-danger">*</span></label>
        <input type="text" class="form-control" id="RepetitiveStrainInjuryDetails"
          formControlName="RepetitiveStrainInjuryDetails" placeholder="{{ getTranslation('placeholder.enterDetails') }}"  maxlength="100">

        <div *ngIf="submitted && physicalAbilityForm.controls['RepetitiveStrainInjuryDetails'].invalid"
          class="text-danger">
          {{ getTranslation('validation.requiredField') }}
        </div>

      </div>

      <div class="form-group col-12 mb-3" *ngIf="physicalAbilityForm.get('HasRepetitiveStrainInjury')?.value === true">
        <label for="AffectedAreas" class="form-label">{{ getTranslation('physicalAbility.affectedAreas') }} <span
            class="text-danger">*</span></label>
        <input type="text" class="form-control" id="AffectedAreas" formControlName="AffectedAreas"
          placeholder="{{ getTranslation('placeholder.enterDetails') }}"  maxlength="500" >

        <div *ngIf="submitted && physicalAbilityForm.controls['AffectedAreas'].invalid" class="text-danger">
          {{ getTranslation('validation.requiredField') }}
        </div>

      </div>


    </div>
  </div>

  <!-- Buttons -->

 <!-- Buttons start -->
 <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive" *ngIf="!isPreviewMode && isEditable">
  <button type="button" class="btn savedraftbtn" 
          *ngIf="physicalAbilityForm.get('SaveMode')?.value !== SaveMode.SAVE"
          (click)="onSubmit(SaveMode.DRAFT)">
    <i class="fas fa-save mr-2"></i>{{ getTranslation('button.saveAsDraft') }}
  </button>
  <button type="button" class="btn prevbtn" (click)="goToBack()">
    <i class="fas fa-arrow-left mr-2"></i>{{ getTranslation('button.previous') }}
  </button>
  <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE)">
    <i class="fas fa-arrow-right mr-2"></i>{{ getTranslation('button.next') }}
  </button>
</div>
 <!-- Buttons ends -->

</form>